import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { tradingPriviledges, commitmentComp } from "../../data";
import { motion } from "framer-motion";
import PropTypes from "prop-types";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import { Link } from "react-router-dom";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary, {
	accordionSummaryClasses,
} from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import traders4 from "../../assets/traders4.jpg";
import traders3 from "../../assets/traders3.jpg";
import { AiOutlineFileProtect } from "react-icons/ai";
import { domain } from "../../data";

function TradeAllDay() {
	const Accordion = styled((props) => (
		<MuiAccordion disableGutters elevation={0} square {...props} />
	))(({ theme }) => ({
		border: `1px solid ${theme.palette.divider}`,
		"&:not(:last-child)": {
			borderBottom: 0,
		},
		"&::before": {
			display: "none",
		},
	}));

	const AccordionSummary = styled((props) => (
		<MuiAccordionSummary
			expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
			{...props}
		/>
	))(({ theme }) => ({
		backgroundColor: "rgba(0, 0, 0, .03)",
		flexDirection: "row-reverse",
		[`& .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded}`]:
			{
				transform: "rotate(90deg)",
			},
		[`& .${accordionSummaryClasses.content}`]: {
			marginLeft: theme.spacing(1),
		},
		...theme.applyStyles("dark", {
			backgroundColor: "rgba(255, 255, 255, .05)",
		}),
	}));

	const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
		padding: theme.spacing(2),
		borderTop: "1px solid rgba(0, 0, 0, .125)",
	}));

	const [expanded, setExpanded] = React.useState("panel1");

	const handleChange = (panel) => (event, newExpanded) => {
		setExpanded(newExpanded ? panel : false);
	};

	const dataContent = [
		{
			title: `${domain} Trader`,
			ac: "DT",
			msg: "The options and multipliers trading platform.",
			id: 1,
		},
		{
			title: `${domain} Bot`,
			ac: "DB",
			msg: "The ultimate trading platform.",
			id: 2,
		},
		{
			title: `SmartTrader`,
			ac: "ST",
			msg: "The legacy option trading platform.",
			id: 3,
		},
		{
			title: `${domain} Go`,
			ac: "GO",
			msg: "The mobile app trading multiplier and accumulator",
			id: 4,
		},
	];

	// return (

	// 	<Box variant="section">
	// 		{tradingPriviledges.map((dt) => (
	// 			<Accordion
	// 				key={dt.id}
	// 				expanded={expanded === dt.id}
	// 				onChange={handleChange(dt.id)}>
	// 				<AccordionSummary
	// 					aria-controls={`${dt.id}d-content`}
	// 					id={`${dt.id}d-header`}>
	// 					<Typography component="">
	// 						{dt.name}{" "}
	// 						{/* <Box sx={{ height: "0.9rem", color: "yellow" }}>{dt.icon}</Box> */}
	// 					</Typography>
	// 				</AccordionSummary>
	// 				<AccordionDetails>
	// 					<Typography sx={{ fontSize: "0.9rem", color: "gray" }}>
	// 						{dt.msg}
	// 						<Link
	// 							to="/en/register"
	// 							className="px-[1rem]  inline-block  py-[0.2rem]  my-[0.5rem]  text-white min-w-[4rem]  border-2  bg-[#03045e]">
	// 							Explore &#8599;
	// 						</Link>
	// 					</Typography>
	// 				</AccordionDetails>
	// 			</Accordion>
	// 		))}
	// 		{/* <Accordion
	// 			expanded={expanded === "panel1"}
	// 			onChange={handleChange("panel1")}>
	// 			<AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
	// 				<Typography component="span">Collapsible Group Item #1</Typography>
	// 			</AccordionSummary>
	// 			<AccordionDetails>
	// 				<Typography>
	// 					Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
	// 					malesuada lacus ex, sit amet blandit leo lobortis eget. Lorem ipsum
	// 					dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada
	// 					lacus ex, sit amet blandit leo lobortis eget.
	// 				</Typography>
	// 			</AccordionDetails>
	// 		</Accordion>
	// 		<Accordion
	// 			expanded={expanded === "panel2"}
	// 			onChange={handleChange("panel2")}>
	// 			<AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
	// 				<Typography component="span">Collapsible Group Item #2</Typography>
	// 			</AccordionSummary>
	// 			<AccordionDetails>
	// 				<Typography>
	// 					Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
	// 					malesuada lacus ex, sit amet blandit leo lobortis eget. Lorem ipsum
	// 					dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada
	// 					lacus ex, sit amet blandit leo lobortis eget.
	// 				</Typography>
	// 			</AccordionDetails>
	// 		</Accordion>
	// 		<Accordion
	// 			expanded={expanded === "panel3"}
	// 			onChange={handleChange("panel3")}>
	// 			<AccordionSummary aria-controls="panel3d-content" id="panel3d-header">
	// 				<Typography component="span">Collapsible Group Item #3</Typography>
	// 			</AccordionSummary>
	// 			<AccordionDetails>
	// 				<Typography>
	// 					Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
	// 					malesuada lacus ex, sit amet blandit leo lobortis eget. Lorem ipsum
	// 					dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada
	// 					lacus ex, sit amet blandit leo lobortis eget.
	// 				</Typography>
	// 			</AccordionDetails>
	// 		</Accordion> */}
	// 	</Box>
	// );

	const content = (
		<section className="w-full">
			<ul className="min-w-full">
				{dataContent.map((dt) => (
					<li
						key={dt.id}
						className=" w-full flex justify-start  items-center  gap-[0.5rem]   p-[0.5rem]">
						<span
							className={` p-[0.5rem]   ${dt.ac === "ST" ? "bg-blue-500" : "bg-red-500"}     font-bold    inline-block text-white  rounded-md`}>
							{dt.ac}
						</span>
						<div className="w-[60%]  text-start">
							<p className="text-[0.8rem]  tracking-wide    font-bold ">
								{dt.title}
							</p>
							<p className="text-[0.7rem]   text-gray-400 ">{dt.msg}</p>
						</div>

						<Link
							to="/en/register"
							className="bg-red-500  grid place-content-center   font-bold     inline-block  px-[0.5rem]  py-[0.1rem]    text-white   rounded-md">
							Open
						</Link>
					</li>
				))}
			</ul>
		</section>
	);

	return content;
}

function TradingPrivileges() {
	return (
		<motion.section
			animate={{ opacity: 0, y: 70 }}
			whileInView={{ opacity: 1, y: 0 }}
			transition={{ duration: 1 }}
			className="w-[90%]   my-[4rem]  mx-auto text-left sm:text-center  ">
			{/* <img src={traders4} alt="traders" /> */}
			<h2 className="text-red-500  my-[1rem] font-serif text-[1.5rem]  tracking-wide ">
				Trade at all time times
			</h2>
			<h5 className="  sm:w-[70%] my-[0.5rem] mx-auto   font-extralight tracking-wide  ">
				Cryptocurrencies and our unique Synthetic Indices are available 24/7.
			</h5>

			<TradeAllDay />
			{/* 
			<ul className=" w-[99%] mx-auto  grid grid-cols-1   sm:grid-cols-2  lg:grid-cols-4 my-[1rem] place-content-center  gap-4    ">
				{tradingPriviledges.map((data) => (
					<motion.li
						key={data.id}
						animate={{ opacity: 0, y: 30 }}
						whileInView={{ opacity: 1, y: 0 }}
						transition={{ duration: 1 }}
						className=" w-[90%] mx-auto  min-h-[6rem]  lg:h-[18rem]    p-[0.8rem]  text-left flex flex-col  gap-[0.5rem]   bg-opacity-20 bg-[#4c4c4d]  ">
						<h4 className="font-serif  text-black">{data.name}</h4>
						{data.icon}
						<div className=" flex   flex-col  justify-around    items-center gap-3">
							<p className="p-[0.4]  text-[0.8]  text-gray-500">{data.msg}</p>
						</div>
					</motion.li>
				))}
			</ul> */}
		</motion.section>
	);
}

function Commitment() {
	const Item = styled(Paper)(({ theme }) => ({
		backgroundColor: "#fff",
		...theme.typography.body2,
		padding: theme.spacing(1),
		textAlign: "center",
		color: (theme.vars ?? theme).palette.text.secondary,
		maxWidth: 400,
		...theme.applyStyles("dark", {
			backgroundColor: "#1A2027",
		}),
	}));

	const message = `Truncation should be conditionally applicable on this long line of text
as this is a much longer line than what the container can support.`;

	const content = (
		<Box
			sx={{
				width: "100%",
				marginX: "auto",
				flexGrow: 1,
				overflow: "hidden",
				px: 0.3,
			}}>
			<Typography
				variant="h6"
				sx={{
					minWidth: "100%",
					fontWeight: "bold",
					textAlign: "center",
					my: "1rem",
				}}>
				<AiOutlineFileProtect className="text-[5rem]  mx-auto " />
				Our Commitment to Compliance and Your Protection{" "}
			</Typography>
			{commitmentComp.map((dt) => (
				<Item
					key={dt.id}
					sx={{
						my: 1,
						mx: "auto",
						p: 2,
						width: "100%",
					}}>
					<Stack spacing={2} direction="row" sx={{ alignItems: "center" }}>
						<Avatar sx={{ color: "red" }}>{dt.icon}</Avatar>
						<Box>
							<Typography variant="h5" sx={{ fontSize: "0.9rem" }}>
								{dt.hd}
							</Typography>
							<Typography sx={{ fontSize: "0.7rem", color: "gray" }}>
								{dt.msg}
							</Typography>
						</Box>
					</Stack>
				</Item>
			))}
			<Link
				to="en/register"
				className="bg-red-700  mx-auto block  max-w-[10rem]  my-[1rem] text-center  rounded-md shadow-md shadow-gray-500 px-[1rem]  capitalize text-white  py-2  ">
				Register Now
			</Link>

			{/* <Item sx={{ my: 1, mx: "auto", p: 2 }}>
				<Stack spacing={2} direction="row" sx={{ alignItems: "center" }}>
					<Stack>
						<Avatar>W</Avatar>
					</Stack>
					<Stack sx={{ minWidth: 0 }}>
						<Typography noWrap>{message}</Typography>
					</Stack>
				</Stack>
			</Item> */}
		</Box>
	);

	return content;
}

function CustomTabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}>
			{value === index && <Box sx={{ p: 3 }}>{children}</Box>}
		</div>
	);
}

CustomTabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.number.isRequired,
	value: PropTypes.number.isRequired,
};

function a11yProps(index) {
	return {
		id: `simple-tab-${index}`,
		"aria-controls": `simple-tabpanel-${index}`,
	};
}

export default function TabLand() {
	const [value, setValue] = React.useState(0);

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	return (
		<Box
			sx={{
				width: "100%",
				overflow: "scroll",
				bgcolor: "black",
				color: "white",
				px: 0.3,
			}}>
			<h4 className="font-bold m-[1rem]  tracking-wide">Trader's hub </h4>
			<p className="w-full   ml-[1rem]  text-gray-300  text-[0.9rem]  p-[0.5rem]  ">
				Explore the real & demo account features, while having up to $10,000.00
				in demo account to practice.{" "}
				<Link
					to="/en/register"
					className="  bg-red-500  text-white   ml-[0.3rem]  px-[0.4rem] font-medium    inline-block  py-[0.1rem]  rounded-[0.5rem]">
					Let's Go
				</Link>
			</p>

			<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
				<Tabs
					value={value}
					onChange={handleChange}
					aria-label="basic tabs example">
					<Tab sx={{ color: "white" }} label="Options" {...a11yProps(0)} />
					<Tab
						sx={{ color: "white" }}
						label="security Compliance"
						{...a11yProps(1)}
					/>
				</Tabs>
			</Box>
			<p className="text-gray-300  text-[0.9rem]  p-[0.5rem]  ">
				Predict the market, profit if you're right, risk only what you put in.
			</p>
			<CustomTabPanel value={value} index={0}>
				<TradingPrivileges />
			</CustomTabPanel>
			<CustomTabPanel value={value} index={1}>
				<Commitment />
			</CustomTabPanel>
		</Box>
	);
}
